/* eslint-disable react/prop-types */
import React from "react";
import { Doughnut, Pie } from "react-chartjs-2";
import numberFormat from "../common/number-format";
import "./AnalyticsCardsRow.css";

export const AnalyticsCardsRow = ({
  vendorActive,
  vendorInActive,
  vendorAnaDetails = [],
  poPayemntDetails = {},
  poStatusDetails = {},
  amountAnaDetails = {},
}) => {
  const requestData = {
    labels: ["Pending", "Completed"],
    datasets: [
      {
        data: [poPayemntDetails.Pending ?? 0, poPayemntDetails.Completed ?? 0],
        backgroundColor: ["#4F46E5", "#F34F81"],
        borderWidth: 0,
      },
    ],
  };

  const requestOptions = {
    plugins: {
      legend: { display: false },
    },
  };

  const orderData = {
    labels: ["Draft", "Confirmed", "Cancelled"],
    datasets: [
      {
        data: [
          poStatusDetails.Draft ?? 0,
          poStatusDetails.Confirmed ?? 0,
          poStatusDetails.Cancelled ?? 0,
        ],
        backgroundColor: ["#4F46E5", "#F34F81", "#70B944"],
        borderWidth: 0,
      },
    ],
  };

  const orderOptions = {
    cutout: "80%",
    plugins: { legend: { display: false } },
  };

  const amountDataArray = [
    { label: "Paid", value: amountAnaDetails.paid ?? 0, color: "#5EC493" },
    {
      label: "Pending",
      value: amountAnaDetails.pending ?? 0,
      color: "#F44336",
    },
  ];

  const amountData = {
    labels: amountDataArray.map((item) => item.label),
    datasets: [
      {
        data: amountDataArray.map((item) => item.value),
        backgroundColor: amountDataArray.map((item) => item.color),
        borderWidth: 0,
        cutout: "80%", // inner cut
        circumference: 180, // half circle
        rotation: 270, // start from left
        borderRadius: 10,
      },
    ],
  };

  const amountOptions = {
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };

  return (
    <div className="row g-4 mt-0">
      {/* Vendor Analytics */}
      <div className="col-md-3">
        <div className="card p-3 border-0 rounded-4 h-100">
          <h6 className="fw-bold">Vendor analytics</h6>
          <div className="d-flex justify-content-center mb-3 gap-2">
            <div
              className="flex-grow-1 d-flex flex-column justify-content-center align-items-center"
              style={{
                borderRadius: "16px",
                backgroundColor: "#E4FFF0",
                height: "60px",
              }}
            >
              <div className="fs-10 fw-500 textGreDark">ACTIVE</div>
              <div className="fs-16 fw-500 textcolor">{vendorActive}</div>
            </div>
            <div
              className="flex-grow-1 d-flex flex-column justify-content-center align-items-center"
              style={{
                borderRadius: "16px",
                backgroundColor: "#FFEDF2",
                height: "60px",
              }}
            >
              <div className="fs-10 fw-500 textRedDark">INACTIVE</div>
              <div className="fs-16 fw-500 textcolor">{vendorInActive}</div>
            </div>
          </div>
          {(vendorAnaDetails ?? []).map((item) => {
            const total = item.active + item.inactive || 1;
            const inactiveWidth = (item.inactive / total) * 100;
            const activeWidth = (item.active / total) * 100;

            return (
              <div key={item.stage} className="mb-3">
                <div className="d-flex justify-content-between mb-1">
                  <span className="fw-500">{item.stage}</span>
                  <span className="fw-600">
                    {item.active + item.inactive}
                  </span>
                </div>
                <div className="d-flex gap-2">
                  {item.inactive > 0 && (
                    <div
                      className="status-bar inactive"
                      style={{
                        width: `${inactiveWidth}%`,
                        minWidth: "30px",
                        height: "16px",
                      }}
                    >
                      {item.inactive}
                    </div>
                  )}
                  {item.active > 0 && (
                    <div
                      className="status-bar active"
                      style={{
                        width: `${activeWidth}%`,
                        minWidth: "30px",
                        height: "16px",
                      }}
                    >
                      {item.active}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Purchase Request Analytics */}
      <div className="col-md-3">
        <div className="card p-3 border-0 rounded-4 h-100">
          <h6 className="fw-bold">PO Payment Analytics</h6>
          <div
            style={{ height: "250px" }}
            className="d-flex justify-content-center"
          >
            <Pie
              data={requestData}
              options={requestOptions}
              className="rounded-circle p-3"
              style={{ backgroundColor: "#F8F8F8" }}
            />
          </div>
          <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div className="d-flex align-items-center gap-2">
                <span
                  style={{
                    width: "10px",
                    height: "10px",
                    backgroundColor: "#4F46E5",
                    borderRadius: "50%",
                    display: "inline-block",
                  }}
                ></span>
                <span>Pending</span>
              </div>
              <span className="fw-semibold">
                {poPayemntDetails.Pending ?? 0}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div className="d-flex align-items-center gap-2">
                <span
                  style={{
                    width: "10px",
                    height: "10px",
                    backgroundColor: "#F34F81",
                    borderRadius: "50%",
                    display: "inline-block",
                  }}
                ></span>
                <span>Completed</span>
              </div>
              <span className="fw-semibold">
                {poPayemntDetails.Completed ?? 0}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Purchase Order Analytics */}
      <div className="col-md-3">
        <div className="card p-3 border-0 rounded-4 h-100">
          <h6 className="fw-bold">Po Status Analytics</h6>
          <div
            className="d-flex justify-content-center"
            style={{ height: "250px", position: "relative" }}
          >
            <Doughnut
              className="rounded-circle p-3"
              style={{ backgroundColor: "#F8F8F8" }}
              data={orderData}
              options={orderOptions}
            />
            <div
              style={{
                position: "absolute",
                top: "40%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
              }}
            >
              <h5 className="fw-bold mb-0">
                {poStatusDetails.total ?? 0}
              </h5>
              <small>Total order</small>
            </div>
          </div>
          <div className="mt-1">
            <div className="d-flex justify-content-between align-items-center mb-1">
              <div className="d-flex align-items-center gap-2">
                <span
                  style={{
                    width: "10px",
                    height: "10px",
                    backgroundColor: "#4F46E5",
                    borderRadius: "50%",
                    display: "inline-block",
                  }}
                ></span>
                <span>Draft</span>
              </div>
              <span className="fw-semibold">
                {poStatusDetails.Draft ?? 0}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div className="d-flex align-items-center gap-2">
                <span
                  style={{
                    width: "10px",
                    height: "10px",
                    backgroundColor: "#F34F81",
                    borderRadius: "50%",
                    display: "inline-block",
                  }}
                ></span>
                <span>Confirmed</span>
              </div>
              <span className="fw-semibold">
                {poStatusDetails.Confirmed ?? 0}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div className="d-flex align-items-center gap-2">
                <span
                  style={{
                    width: "10px",
                    height: "10px",
                    backgroundColor: "#70B944",
                    borderRadius: "50%",
                    display: "inline-block",
                  }}
                ></span>
                <span>Cancelled</span>
              </div>
              <span className="fw-semibold">
                {poStatusDetails.Cancelled ?? 0}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Amount Analytics */}
      <div className="col-md-3">
        <div className="bg-white rounded-4 p-3 h-100">
          <h6 className="fw-bold mb-3">Amount analytics</h6>
          <div className="d-flex justify-content-center">
            <div
              className="d-flex justify-content-center"
              style={{ height: "175px", position: "relative" }}
            >
              <Doughnut data={amountData} options={amountOptions} />
            </div>
          </div>
          <div className="mt-3">
            {amountDataArray.map((item) => (
              <div
                key={item.label}
                className="d-flex justify-content-between align-items-center mb-2"
              >
                <div className="d-flex align-items-center gap-2">
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: item.color,
                      borderRadius: "50%",
                      display: "inline-block",
                    }}
                  ></span>
                  <span>{item.label}</span>
                </div>
                <span className="fw-semibold">
                  ₹{item.value.toLocaleString()}
                </span>
              </div>
            ))}
          </div>
          <div
            className="p-3 mt-2 rounded-3"
            style={{ backgroundColor: "#F4F3FF" }}
          >
            <p className="mb-1 fw-semibold">Total amount</p>
            <h5 className="fw-bold text-primary mb-0">
              ₹{numberFormat(amountAnaDetails.total ?? 0)}
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
};
